import { createSlice } from '@reduxjs/toolkit';

export const boardSlice = createSlice({
    name: "board",
    initialState: {
        Id: null,
        Description: '',
        Background: null,
        Members: [],
    },
    reducers: {
        set: (state, action) => {
            state = action.payload;
            return state;
        }
    }
})

export const boardActions = boardSlice.actions;

export default boardSlice.reducer;